import React, { useEffect, useState } from 'react';
import Banner from 'components/Banner';
import AppDownloadPopup from 'components/AppDownloadPopup';
import { Container } from './index.elements';

interface StorageData {
  dismissCount: number;
  lastDismissDate: number;
}

const STORAGE_KEY = 'install_header';
const MAX_DISMISSALS = 1;
const RESET_INTERVAL = 30 * 24 * 60 * 60 * 1000;

const AppDownloadHeader: React.FC = () => {
  const baseClass = 'app-download-header';

  const [showGuide, setShowGuide] = useState<boolean>(false);
  const [isVisible, setIsVisible] = useState<boolean>(true);
  const [shouldShow, setShouldShow] = useState<boolean>(false);
  const isIOS = /ipad|iPhone|iPod/.test(navigator.userAgent);
  const storeData = localStorage.getItem(STORAGE_KEY);
  const isStandAlone = window.matchMedia('(display-mode: standalone)').matches;
  const now = Date.now();

  useEffect(() => {
    checkStatus();
  }, []);

  const checkStatus = async () => {
    // check if pwa in already installed
    const relatedApps = await (navigator as any).getInstalledRelatedApps();
    const PWAisInstalled = relatedApps.length > 0;

    // If the app is already installed in the device we dont show the header
    if (PWAisInstalled || isStandAlone) return;

    if (storeData) {
      const data: StorageData = JSON.parse(storeData);

      const isDatePassed = now - data.lastDismissDate >= RESET_INTERVAL;

      if (isDatePassed || data.dismissCount < MAX_DISMISSALS) {
        localStorage.setItem(
          STORAGE_KEY,
          JSON.stringify({
            dismissCount: isDatePassed ? 0 : data.dismissCount++,
            lastDismissDate: now
          })
        );
        setShouldShow(true);
      }
    } else {
      setShouldShow(true);
    }
  };

  const handleClose = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();

    let data: StorageData;

    if (storeData) {
      data = JSON.parse(storeData);
      data.dismissCount += 1;
      data.lastDismissDate = now;
    } else {
      data = {
        dismissCount: 1,
        lastDismissDate: now
      };
    }

    localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    setIsVisible(false);
  };

  const showPopupIOS = (status: boolean): void => {
    setShowGuide(status);
  };

  if (!shouldShow) return null;

  return (
    <>
      <Container
        className={baseClass}
        isVisible={isIOS && isVisible}
        onClick={() => setShowGuide(true)}
      >
        <Banner
          type={'info'}
          message={'You can Download OmniBlu into your Mobile device'}
          onClose={(e) => handleClose(e)}
        />
      </Container>
      {showGuide && isIOS && <AppDownloadPopup onClose={showPopupIOS} />}
    </>
  );
};

export default AppDownloadHeader;
